import {NgModule} from 'ng-metadata/core';
import {IconComponent} from './icon.component';
import {IconButtonComponent} from './icon-button.component';

/**
 * @ngdoc module
 * @name mw.components.icon
 * @description
 *
 * Icons
 */
@NgModule({
    declarations: [IconComponent, IconButtonComponent]
})
export class IconModule {}



// WEBPACK FOOTER //
// ./src/lib/components/icon/icon.module.ts